
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, MapPin } from "lucide-react";

export const BartenderSchedulePage = () => {
  const mockShifts = [
    { id: 1, date: "2023-11-15", time: "8:00 PM - 2:00 AM", venue: "Club Neon", position: "Lead Bartender" },
    { id: 2, date: "2023-11-18", time: "9:00 PM - 3:00 AM", venue: "Skyline Lounge", position: "Bartender" },
    { id: 3, date: "2023-11-20", time: "7:00 PM - 1:00 AM", venue: "The Basement", position: "Bar Back" },
  ];

  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Shift Schedule</h1>
        <div className="flex gap-2">
          <Button variant="outline">
            <Calendar className="mr-2 h-4 w-4" />
            Calendar View
          </Button>
          <Button variant="default">
            <Clock className="mr-2 h-4 w-4" />
            Request Time Off
          </Button>
        </div>
      </div>

      <div className="grid gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Upcoming Shifts</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {mockShifts.map((shift) => (
                <div key={shift.id} className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex items-center gap-4">
                    <div className="bg-teal-100 p-3 rounded-full">
                      <MapPin className="h-6 w-6 text-teal-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold">{shift.venue}</h3>
                      <p className="text-sm text-muted-foreground">{shift.position}</p>
                      <p className="text-sm text-muted-foreground">{shift.date} • {shift.time}</p>
                    </div>
                  </div>
                  <Button variant="outline" size="sm">View Details</Button>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Available Shifts</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 border rounded-lg border-dashed">
                <div className="flex items-center gap-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <MapPin className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold">Skyline Lounge</h3>
                    <p className="text-sm text-muted-foreground">Bartender</p>
                    <p className="text-sm text-muted-foreground">Nov 25 • 9:00 PM - 3:00 AM</p>
                  </div>
                </div>
                <Button variant="outline" size="sm">Pick Up Shift</Button>
              </div>
              <div className="flex items-center justify-between p-4 border rounded-lg border-dashed">
                <div className="flex items-center gap-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <MapPin className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold">Club Neon</h3>
                    <p className="text-sm text-muted-foreground">Bar Back</p>
                    <p className="text-sm text-muted-foreground">Nov 27 • 8:00 PM - 2:00 AM</p>
                  </div>
                </div>
                <Button variant="outline" size="sm">Pick Up Shift</Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
